import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { collection: { save, fetchById } }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleDuplicateEntry = useCallback(async row => {
    const { id, title, slug } = row

    const data = await fetchById(id)
    if (!data) return;

    data.id = null
    data.duplicate_id = id
    data.title = title
    data.slug = slug
    data.tags = data.tags.map(tag => tag.id)
    if (!data.content) delete data.content

    await save(data)
    await handleRefresh()
  }, [fetchById, save, handleRefresh])

  const handleMoveEntry = useCallback(async row => {
    const { id, content_type } = row

    const data = await fetchById(id)
    if (!data) return

    data.content_type = content_type
    await save(data)
    await handleRefresh()
  }, [fetchById, save, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
    handleMoveEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry, handleMoveEntry])
}
